import {List, ListItem, ListItemAvatar, ListItemText, Typography} from "@mui/material";
import SteddiContainer from "../../General/SteddiContainer";
import React from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import {CalendarDays, Coins, InfoIcon, Scroll} from "lucide-react";
import DynamicListItem from "../../General/DynamicListItem";
import SectionHeader from "../../General/SectionHeader";
import EnergiKonto from "../../Esign/InfoItems/EnergiKonto";

export default function InitialCancelPage() {

  return (
    <>
      <Grid2 container spacing={5}>
        <Grid2 xs={12}>
          <SteddiContainer>
            <SectionHeader>Hva betyr det for meg</SectionHeader>
            <List sx={{pb: 0}} className="no-left-pad-list">
              <DynamicListItem>
                <ListItemAvatar>
                  <Coins/>
                </ListItemAvatar>
                <ListItemText>
                  Ved avbestilling av Forutsigbar Betaling vil du enten få igjen penger eller måtte betale et restbeløp basert på din saldo. Saldoen din ser du i neste steg.
                </ListItemText>
              </DynamicListItem>
              <DynamicListItem>
                <ListItemAvatar>
                  <CalendarDays/>
                </ListItemAvatar>
                <ListItemText>
                  Etter avbestilling mottar du opphørsfaktura første virkedagen i neste måned.
                </ListItemText>
              </DynamicListItem>
              <DynamicListItem>
                <ListItemAvatar>
                  <Scroll/>
                </ListItemAvatar>
                <ListItemText>
                  Etter avbestilling, vil du motta strømregninger som følger strømforbruket ditt, direkte fra din strømleverandør. Vi anbefaler at du sjekker med din strømleverandør at de sender fakturaen til deg slik du ønsker.
                </ListItemText>
              </DynamicListItem>
            </List>
          </SteddiContainer>
        </Grid2>
        <Grid2>
          <SteddiContainer padding="sm" background={"tertiary"}>
            <EnergiKonto/>
          </SteddiContainer>
          <List>
            <ListItem>
              <ListItemAvatar>
                <InfoIcon/>
              </ListItemAvatar>
              <ListItemText>
                <Typography>
                  Dersom adresse ikke stemmer må du gå tilbake til strømleverandøren sin side og velge riktig adresse.
                </Typography>
              </ListItemText>
            </ListItem>
          </List>
        </Grid2>
      </Grid2>
    </>
  )
}